import { useQuery } from '@tanstack/react-query'

import { RewardProgramStatus } from '@pages/RewardsHub/RewardHubDto'

import { useAccountReadContext } from '@context/AccountContextContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const useRewardPrograms = () => {
  const apiClient = useApiClient(ClientApiClient)
  const { account } = useAccountReadContext()
  const tickmillCompanyId = account?.tickmillCompany.id
  const countryId = account?.nationalities.find((n) => n.isPrimary)?.id

  const now = new Date().toISOString()

  const { data: rewardProgramsData, isLoading } = useQuery({
    queryKey: ['rewardPrograms', tickmillCompanyId, countryId],
    queryFn: () => apiClient.getRewardPrograms(now, tickmillCompanyId, countryId),
  })

  const activeRewardPrograms = rewardProgramsData
    ? {
        ...rewardProgramsData,
        items: rewardProgramsData.items.filter(
          (rp) => rp.programStatus.id === RewardProgramStatus.ACTIVE
        ),
      }
    : undefined

  return { rewardPrograms: activeRewardPrograms, isLoading }
}
